export default __webpack_public_path__ + "static/media/Blog1_4.2896af83.jpg";